import { Link } from "react-router-dom";
import { ArrowLeft, Sparkles } from "lucide-react";

const COPY = {
  signin: {
    title: "Sign In",
    blurb:
      "Customer portal access. View your service history, photo proofs, and manage your subscription.",
    ribbon: "Phase 2 · Coming Soon",
  },
  signup: {
    title: "Sign Up",
    blurb:
      "Online signup launches in our next phase. In the meantime, browse plans or send us a note and we'll set you up manually.",
    ribbon: "Phase 2 · Coming Soon",
  },
  notfound: {
    title: "Page Not Found",
    blurb:
      "That page doesn't exist on Silky Smooth. Let's get you back to fresh bins.",
    ribbon: "404",
  },
};

export default function AuthPlaceholder({ mode = "signin" }) {
  const copy = COPY[mode] || COPY.signin;
  return (
    <section
      className="relative bg-gradient-to-b from-brand-50 to-white min-h-[calc(100vh-5rem)] flex items-center"
      data-testid={`page-${mode}`}
    >
      <div className="container-page relative py-20">
        <div className="max-w-xl mx-auto text-center">
          <span className="inline-flex items-center gap-2 bg-white border border-brand-100 text-brand-700 text-[11px] font-bold uppercase tracking-[0.22em] px-3 py-1.5 rounded-full mb-7 shadow-soft">
            <Sparkles size={12} /> {copy.ribbon}
          </span>
          <h1 className="font-heading text-5xl sm:text-6xl font-extrabold tracking-tight text-ink text-balance">
            {copy.title}
          </h1>
          <p className="mt-6 text-lg text-slate-600 leading-relaxed">
            {copy.blurb}
          </p>
          <div className="mt-9 flex flex-wrap items-center justify-center gap-4">
            <Link to="/" className="btn-primary" data-testid="placeholder-home-cta">
              <ArrowLeft size={14} />
              Return Home
            </Link>
            <Link
              to="/plans"
              className="btn-secondary"
              data-testid="placeholder-plans-cta"
            >
              Browse Plans
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
